/* eslint-disable @typescript-eslint/unbound-method */
import { forwardRef, Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { ResendVerificationService } from '@se-po/shared-data-access-services'
import { first } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
  useExisting: forwardRef(() => VerificationSubmitService),
  deps: [Router, ResendVerificationService]
})
export abstract class VerificationSubmitter {
  public abstract submitting: boolean
  public abstract unknownError: boolean
  public abstract resendAccountActivated: boolean
  public abstract resendSuccess: boolean
  public abstract signIn(signInForm: HTMLFormElement): void
  public abstract reset(store: StoreService): void
  public abstract resend(accountUuid: string, userReturnTo?: string): void
}

@Injectable({
  providedIn: 'root'
})
export class VerificationSubmitService implements VerificationSubmitter {
  public submitting = false
  public unknownError = false
  public resendAccountActivated = false
  public resendSuccess = false

  constructor(
    public router: Router,
    private resendService: ResendVerificationService,
  ) {}

  public signIn(signInForm: HTMLFormElement): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    signInForm.nativeElement.submit()
  }

  public reset(store: StoreService): void {
    const path = store.authSession?.brand === 'team_unify'
      ? [store.basePath, 'self']
      : [store.basePath]

    this.router.navigate(path)
  }

  public resend(accountUuid: string, userReturnTo?: string): void {
    this.submitting = true
    this.resendService.resend(accountUuid, userReturnTo)
      .pipe(first())
      .subscribe(
        (result) => {
          this.submitting = false
          if (result.success) this.resendSuccess = true
          else this.unknownError = true
        },
        (error) => {
          this.submitting = false
          if (error.error?.error === 'ALREADY_ACTIVATED') {
            this.resendAccountActivated = true
          }
          else this.unknownError = true
        }
      )
  }
}
